<template>
    <bottom-sheet :default-state="currentState">
        <div v-show="sheet == 'categorysheet'">
            <div
                @click="$emit('closed')"
                class="btn btn-square btn-sm btn-ghost absolute right-0 m-1 z-40"
            >
                <span class="material-symbols-outlined notranslate fill-current"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg></span>
            </div>
            <div class="">
                <div class="text-center">
                    <button
                        v-if="showScrollLeftButton"
                        @click="scrollToLeft(-300)"
                        class="absolute left-1 top-16 btn btn-sm btn-ghost btn-active btn-circle z-10  hidden sm:block"
                    >
                        ❮
                    </button>
                    <button
                        v-if="showScrollRightButton"
                        @click="scrollToLeft(300)"
                        class="absolute right-1 top-16 btn btn-sm btn-ghost btn-active btn-circle z-10  hidden sm:block"
                    >
                        ❯
                    </button>
                    <div
                        @scroll="checkScrollButtons"
                        id="scrollContainer"
                        class="carousel carousel-center shadow-lg p-4 py-2 space-x-3 bg-base-100 rounded-box w-full pt-8 h-30 carousel-width"
                    >
                        <div
                            class="carousel-item btn p-2 my-2 mr-0 flex flex-col flex-nowrap items-center p-0 m-2 w-20 border-base-content/5 indicator inline-flex h-20"
                            :class="{ 'btn-active ring ring-primary ring-offset-base-100 ring-offset-2': currentCategoryId === 0 }"  @click="changeCategory(0)"
                        >
                            <span class="text-xs">{{ trans.all }}</span>
                        </div>
                        <div
                            class="carousel-item btn p-2 my-2 mr-0 flex flex-col flex-nowrap items-center p-0 m-2 w-20 border-base-content/5 indicator inline-flex h-20"
                            :class="{ 'btn-active ring ring-primary ring-offset-base-100 ring-offset-2': currentCategoryId === category.id }"
                            v-for="(category, index) in mainCategories"
                            :key="'cate-' + index"
                            @click="
                                category.lower_category_ids.length > 0
                                    ? openSubCategories(category.id)
                                    : changeCategory(
                                          category.id,
                                          category.title
                                      )
                            "
                        >
                            <img
                                :src="category.icon_url"
                                alt=""
                                loading="lazy"
                                class="inline w-8"
                            />
                            <span class="text-xs normal-case">{{ category.title }}</span>
                            <span
                                class="material-symbols-outlined notranslate indicator-item indicator-bottom indicator-center right-2 top-14 fill-current"
                                v-if="category.lower_category_ids.length > 0"
                                ><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"/></svg></span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="sheet == 'subcategorysheet' && currentUpperCategory">
            <div
                @click="$emit('closed')"
                class="btn btn-square btn-sm btn-ghost absolute right-0 m-1 z-40"
            >
                <span class="material-symbols-outlined notranslate fill-current"> 
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                </span>
            </div>
            <div class="">
                <div class="text-center">
                    <button
                        v-if="showScrollLeftButton"
                        @click="scrollToLeft(-300)"
                        class="absolute left-1 top-16 btn btn-sm btn-ghost btn-active btn-circle z-10  hidden sm:block"
                    >
                        ❮
                    </button>
                    <button
                        v-if="showScrollRightButton"
                        @click="scrollToLeft(300)"
                        class="absolute right-1 top-16 btn btn-sm btn-ghost btn-active btn-circle z-10 hidden sm:block"
                    >
                        ❯
                    </button>
                    <div
                        @scroll="checkScrollButtons"
                        id="scrollContainerSubCategory"
                        class="carousel carousel-center shadow-lg p-4 py-2 space-x-3 bg-base-100 rounded-box w-full pt-8 h-30 carousel-width"
                    >
                        <div @click="open('categorysheet')" class="carousel-item btn p-2 my-2 mr-0 flex flex-col flex-nowrap items-center p-0 m-2 w-20 border-base-content/5 indicator inline-flex h-20 btn-ghost bg-base-200">
                            <div class="badge border-base-content/5 btn-sm btn-square">
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m296-345-56-56 240-240 240 240-56 56-184-184-184 184Z"/></svg>
                                </span>
                            </div>
                            <span class="text-xs">{{ trans.back }}</span>
                        </div>
                        <div
                            class="carousel-item btn p-2 my-2 mr-0 flex flex-col flex-nowrap items-center p-0 m-2 w-20 border-base-content/5 indicator inline-flex h-20"
                            :class="{ 'btn-active ring ring-primary ring-offset-base-100 ring-offset-2': categoryId === subCategory.id }"
                            v-for="(subCategory, index) in subCategories"
                            :key="'subcate-' + index"
                            @click="
                                changeCategory(
                                    subCategory.id,
                                    subCategory.title
                                )
                            "
                        >
                            <img
                                :src="subCategory.icon_url"
                                alt=""
                                loading="lazy"
                                class="inline w-8"
                            />
                            <span class="text-xs normal-case">{{ subCategory.title }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </bottom-sheet>
</template>

<script>
import BottomSheet from "./BottomSheet";
import CategoryHelper from "../mixins/Category";
import CarouselHelper from "../mixins/Carousel";

export default {
    inject: ["trans"],
    mixins: [CategoryHelper, CarouselHelper],
    components: {
        BottomSheet,
    },
    props: {
        mapId: {
            type: Number,
            required: true,
        },
        locale: {
            type: String,
            default: "",
        },
        categories: {
            type: Array,
            required: true,
        },
        currentSheet: {
            type: String,
            default: "",
        },
        trans: {
            type: Object,
            required: true
        },
        currentCategoryId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            sheet: this.currentSheet,
            currentState: "open",
            currentUpperCategoryId: "",
            showScrollLeftButton: false,
            showScrollRightButton: true,
            scrollContainer: null
        };
    },
    methods: {
        open(sheet) {
            this.sheet = sheet;
            this.close();
            setTimeout(() => {
                this.currentState = "open";
            }, 500);
        },
        close() {
            this.currentState = "close";
        },
        openSubCategories(upperCategoryId) {
            this.open("subcategorysheet");
            this.currentUpperCategoryId = upperCategoryId;
            this.categoryId = upperCategoryId;
            this.getScrollContainer();
            this.checkScrollButtons();
        },
        scrollToLeft(value) {
            this.scrollContainer.scrollLeft += value;
            this.checkScrollButtons();
        },
        checkScrollButtons() {
            this.getScrollContainer()
            this.showScrollLeftButton = this.scrollContainer.scrollLeft > 0;
            this.showScrollRightButton = this.scrollContainer.scrollLeft < this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
        },
        getScrollContainer() {
            this.scrollContainer = document.getElementById('scrollContainerSubCategory') || document.getElementById('scrollContainer');
        }
    },
    computed: {
        mainCategories() {
            return this.categories.filter(
                (cat) =>
                    cat.lower_category_ids.length > 0 || !cat.upper_category_id
            );
        },
        subCategories() {
            return this.categories.filter((cat) =>
                this.currentUpperCategory.lower_category_ids.includes(cat.id)
            );
        },
        currentUpperCategory() {
            return this.categories.find(
                (el) => el.id == this.currentUpperCategoryId
            );
        },
    },
    mounted() {
        this.getScrollContainer()
    }
};
</script>

<style>
.center-nav {
    left: 50%;
    transform: translate(-50%, 0);
}
.category-img {
    height: 3rem !important;
}
</style>
